import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarShortName',
  standalone: true
})
export class AvatarShortNamePipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) {
      return '';
    }

    const words = value.trim().split(/\s+/);

    const initials = words.slice(0, 2).map((word: string) => word.charAt(0));
    return initials.join('').toUpperCase();
  }
}
